import { render, staticRenderFns } from "./ProcessDesigner.vue?vue&type=template&id=32a734af"
import script from "./ProcessDesigner.vue?vue&type=script&lang=js"
export * from "./ProcessDesigner.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesigner.vue?vue&type=style&index=0&id=32a734af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports